import { InitialState } from '@bc/advertisement/feature/ads-dashboard/store/index';
import { CampaignInfo, CampaignWizard } from '@bc/advertisement/domain';

export default {
  getAdsCampaigns: (state: InitialState): CampaignInfo[] => state.adsCampaigns.data,
  currentCampaign: (state: InitialState): CampaignWizard => state.campaignWizardInfo,
  getAdsList: (state: InitialState) => state.adsList,
  getAdsCampaignMeta: (state: InitialState) => state.adsCampaigns.meta,
};
